import { useEffect } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { IField } from '../../../interfaces/field.interface';
import { Fields } from '../../../components/Fields';
import { SaleOrderAdvanceModel } from '../../../model/sale-order.model';


interface IOwnProps {
  defaultData?: SaleOrderAdvanceModel;
  show: boolean;
  handleClose: () => void;
  handleSubmit: (item: SaleOrderAdvanceModel) => void;
}
const SaleOrderAdvanceModal: React.FC<IOwnProps> = (props: IOwnProps) => {

  const { register, handleSubmit, control, reset } = useForm<SaleOrderAdvanceModel>({
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
    },
    mode: "onTouched",
    reValidateMode: "onChange"
  });

  const fields: Array<IField> = [
    {
      label: "Date",
      required: true,
      props: {
        name: "date",
        type: "date",
        placeholder: "Date"
      },
    }, {
      label: "Narration",
      required: false,
      props: {
        name: "narration",
        type: "string",
        placeholder: "Narration"
      }
    }, {
      label: "Amount",
      required: true,
      props: {
        name: "amt",
        type: "number",
        placeholder: "Amount",
      },
    }
  ];

  useEffect(() => {
    reset(props.defaultData);
    return () => {
      reset();
    }
  }, [reset, props.defaultData]);

  const onSubmit = handleSubmit(async (inputs) => {
    props.handleSubmit(inputs);
    handleClose();
  });

  const handleClose = () => {
    reset();
    props.handleClose();
  };
  return (
    <Modal
      show={props.show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Form onSubmit={onSubmit} noValidate>
        <Modal.Header className="bg-primary-subtle" closeButton>
          <Modal.Title>Advance Payment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Fields fields={fields} control={control} register={register} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">Add to List</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SaleOrderAdvanceModal;